import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Copyright from "../components/Copyright";
import MenuItem from "@material-ui/core/MenuItem";
import { addUser } from "../services/firebase";
import { UserContext } from "../providers/UserProvider";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const grades = [
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
  {
    value: 11,
    label: "11",
  },
  {
    value: 12,
    label: "12",
  },
];

export default function Register() {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [grade, setGrade] = useState(9);
  const [emailList, setEmailList] = useState(false);
  const userState = useContext(UserContext);
  if (userState.doc && userState.doc.exists) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <AllInclusiveIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          TMC Contest Site
        </Typography>
        <Typography color="textSecondary">
          Register with your username and grade.
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                onChange={(event) => setUsername(event.target.value)}
                value={username}
                autoComplete="username"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="grade"
                variant="outlined"
                select
                label="Grade"
                onChange={(event) => setGrade(event.target.value)}
                value={grade}
                style={{ width: "100%" }}
              >
                {grades.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={emailList}
                    onChange={(event) => setEmailList(event.target.checked)}
                    color="primary"
                  />
                }
                label="I want to receive inspiration, resources and updates via email."
                style={{ textAlign: "left" }}
              />
            </Grid>
          </Grid>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => {
              addUser(userState.user, username, grade, emailList);
            }}
          >
            Register
          </Button>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}
